import { useState, useEffect, useCallback } from "react";
export var useInputSearch = function (onSearchChange, delay) {
    if (delay === void 0) { delay = 500; }
    var _a = useState(""), searchValue = _a[0], setSearchValue = _a[1];
    var _b = useState(""), debouncedValue = _b[0], setDebouncedValue = _b[1];
    var handleChangeSearch = function (e) {
        console.log("handleChangeSearch", e.target.value);
        var value = e.target.value;
        setSearchValue(value);
    };
    var handleBlurTextSearch = function (e) {
        // Handle blur event if needed
        console.log("onBlurTextSearch", e.target.value);
    };
    // Memoize the callback to prevent unnecessary re-renders
    var memoizedOnSearchChange = useCallback(function (value) {
        if (onSearchChange) {
            onSearchChange(value);
        }
    }, [onSearchChange]);
    // Debounce effect
    useEffect(function () {
        // Only set up the timer if searchValue has actually changed and is not empty
        if (searchValue !== debouncedValue) {
            var timer_1 = setTimeout(function () {
                setDebouncedValue(searchValue);
                memoizedOnSearchChange(searchValue);
            }, delay);
            return function () {
                clearTimeout(timer_1);
            };
        }
    }, [searchValue, debouncedValue, delay, memoizedOnSearchChange]);
    var inputSearchConfig = {
        placeholderTextSearch: "Buscar usuario",
        disabledSearchInput: false,
        onChangeTextSearch: handleChangeSearch,
        onBlurTextSearch: handleBlurTextSearch,
    };
    return {
        inputSearchConfig: inputSearchConfig,
        searchValue: searchValue,
        setSearchValue: setSearchValue,
        debouncedValue: debouncedValue,
    };
};
